import {
  Button,
  HeadingRegular,
  Modal,
  NavigationItem,
} from '@pensionbee/honeypot-ui';
import { useState } from 'react';
import { useThemedImageSource } from '@/domains/theme/useThemedImageSource';
import { StageProps } from '../../config/StrongerNudgeConfig';

interface CustomerWebBookingOptionProps {
  isConfirmationScreen?: boolean;
}

export const CustomerWebBookingOption = (
  props: CustomerWebBookingOptionProps & { onSubmit: StageProps['onSubmit'] },
) => {
  const { isConfirmationScreen, onSubmit } = props;
  const searchIcon = useThemedImageSource('spot-search');
  const [isOpenCustomerWebBooking, setIsOpenCustomerWebBooking] =
    useState(false);

  const closeCustomerWebBooking = () => setIsOpenCustomerWebBooking(false);
  const openCustomerWebBooking = () => setIsOpenCustomerWebBooking(true);

  const handleGoToPensionWiseWebsite = async () => {
    await onSubmit({
      [isConfirmationScreen
        ? 'guidanceConfirmationOption'
        : 'guidanceAppointmentChoice']: 'Customer Web Booking',
    });
    window.open(
      'https://www.moneyhelper.org.uk/en/pensions-and-retirement/pension-wise/book-a-free-pension-wise-appointment/how-to-book-a-phone-appointment/book-a-phone-appointment',
      '_blank',
      'noopener,noreferrer',
    );
    closeCustomerWebBooking();
  };

  return (
    <>
      <NavigationItem
        handleClick={openCustomerWebBooking}
        title={
          isConfirmationScreen
            ? 'Book a new appointment online'
            : 'Book online now'
        }
        copy={
          isConfirmationScreen
            ? 'Book another appointment with Pension Wise online'
            : 'Book your appointment with Pension Wise online'
        }
        src={searchIcon}
        imageHeight="48px"
      />
      <Modal
        isOpen={isOpenCustomerWebBooking}
        handleClose={closeCustomerWebBooking}
        variant="bottom"
      >
        <div className="flex h-full flex-col justify-between">
          <HeadingRegular className="mb-28">
            You&apos;ll need to confirm you&apos;ve taken guidance before you
            can proceed.
          </HeadingRegular>
          <Button
            className="mb-20 mt-auto w-full md:w-auto"
            onClick={handleGoToPensionWiseWebsite}
          >
            OK
          </Button>
          <Button
            variant="secondary"
            className="mt-auto w-full md:w-auto"
            onClick={closeCustomerWebBooking}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};
